import { FormVariant } from '../form-variant/form-variant';

export class Form {
  key: string | undefined;
  name: string | undefined;
  variants: FormVariant[];
  activeVariant: FormVariant;
  isCustomizable: boolean | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.key = payload.key;
      this.name = payload.name;
      if (payload.variants) {
        this.variants = FormVariant.createFormVariants(payload.variants);
      }
      this.isCustomizable = payload.isCustomizable;
      if (payload.activeVariant) {
        this.activeVariant = new FormVariant(payload.activeVariant);
      }
    }
  }

  static createForms(result: Array<any>): Form[] {
    const variants = new Array<Form>();
    if (result) {
      result.map((model) => {
        variants.push(new Form(model));
      });
    }
    return variants;
  }
}
